import { createSlice } from "@reduxjs/toolkit";

const activeVariantSlice = createSlice({
  name: "activeVariant",
  initialState: {
    activeVariantId: null,
  },
  reducers: {
    setactiveVariant(state, action) {
      state.activeVariantId = action.payload;
    },
  },
});

export const { setactiveVariant } = activeVariantSlice.actions;
export default activeVariantSlice.reducer;
